<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="configs" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" width="">
        </el-table-column>
        <el-table-column prop="ItemName" label="工作项名称" width="" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ApplicableRole" label="适用角色" width="">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ApplicableRole === 0" type="primary">所有</el-tag>
            <el-tag v-else-if="scope.row.ApplicableRole === 1">班主任</el-tag>
            <el-tag v-else-if="scope.row.ApplicableRole === 2" type="success">任课教师</el-tag>
            <el-tag v-else type="info">未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="OrderIndex" label="排序号" width="">
        </el-table-column>
        <el-table-column prop="IsEnable" label="状态" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsEnable ? 'success' : 'danger'">
              {{ scope.row.IsEnable ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="180">
        </el-table-column>
      </el-table>
      </div>

      <!--分页-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="PageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑/新增界面-->
      <el-dialog :title="formTitle" :visible.sync="formVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
          <el-form-item label="工作项名称" prop="ItemName">
            <el-input v-model="editForm.ItemName" auto-complete="off" placeholder="请输入工作项名称"></el-input>
          </el-form-item>
          <el-form-item label="适用角色" prop="ApplicableRole">
            <el-select v-model="editForm.ApplicableRole" placeholder="请选择适用角色" style="width: 100%">
              <el-option label="所有" :value="0"></el-option>
              <el-option label="班主任" :value="1"></el-option>
              <el-option label="任课教师" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序号" prop="OrderIndex">
            <el-input-number v-model="editForm.OrderIndex" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="是否启用" prop="IsEnable">
            <el-switch v-model="editForm.IsEnable" active-text="启用" inactive-text="禁用"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="formVisible = false">取消</el-button>
          <el-button type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getWorkItemConfigList, saveWorkItemConfig, removeWorkItemConfig } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
        itemName: '',
        isEnable: null,
        role: 0
      },
      searchList: [
        {
          label: '名称',
          key: 'itemName',
          width: '150px',
          initValue: ''
        },
        {
          label: "状态",
          key: "isEnable",
          type: "select",
          width: '120px',
          clearable: true,
          initValue: null,
          options: [
            { label: "启用", value: true },
            { label: "禁用", value: false },
          ]
        },
        {
          label: "适用角色",
          key: "role",
          type: "select",
          width: '150px',
          initValue: 0,
          options: [
            { label: "全部", value: 0 },
            { label: "班主任", value: 1 },
            { label: "任课教师", value: 2 },
          ]
        },
      ],
      configs: [],
      total: 0,
      page: 1,
      PageSize: 20,
      listLoading: false,
      buttonList: [],
      currentRow: null,
      departmentId: 0,

      formVisible: false,
      formTitle: '新增配置',
      formLoading: false,
      editForm: {
        Id: 0,
        DepartmentId: 0,
        ItemName: '',
        ApplicableRole: 0,
        OrderIndex: 0,
        IsEnable: true
      },
      formRules: {
        ItemName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        ApplicableRole: [{ required: true, message: "请选择适用角色", trigger: "change" }]
      }
    };
  },
  methods: {
    formatTime(time) {
      return time ? util.formatDate.format(new Date(time), "yyyy-MM-dd HH:mm:ss") : "";
    },
    treeNodeClick(data) {
      const id = treeNodeDeptId(data);
      if (!id) return;
      this.departmentId = id;
      this.page = 1;

      // 彻底清空状态与 UI
      if (this.$refs.toolbar) {
        this.filters.itemName = "";
        this.filters.isEnable = null;
        this.filters.role = 0;

        this.$refs.toolbar.searchObj = {
          itemName: "",
          isEnable: null,
          role: 0
        };
      } else {
        this.filters.itemName = "";
      }

      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleQuery() {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行查询", type: "error" });
        return;
      }
      let para = {
        departmentId: this.departmentId,
        page: this.page,
        PageSize: this.PageSize,
        ...this.filters
      };
      this.listLoading = true;
      console.log("[WorkRecordDebug] WorkItemConfig.handleQuery", {
        component: "WorkItemConfig",
        routePath: this.$route.path,
        api: "/api/WorkRecordAdmin/GetConfigs",
        para
      });
      getWorkItemConfigList(para).then((res) => {
        let result = res.data || res;
        if (result.success) {
          this.configs = result.response.data;
          this.total = result.response.dataCount;
        }
        this.listLoading = false;
      });
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search;
      } else {
        this.filters = { itemName: item.search };
      }
      this[item.Func].apply(this, [item]);
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length > 0 && row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    handleAdd() {
      if (!toDeptId(this.departmentId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行新增", type: "error" });
        return;
      }
      this.formTitle = '新增配置';
      this.editForm = {
        Id: 0,
        DepartmentId: this.departmentId,
        ItemName: '',
        ApplicableRole: 0,
        OrderIndex: 0,
        IsEnable: true
      };
      this.formVisible = true;
    },
    handleEdit() {
      if (!this.currentRow) {
        this.$message.error("请先选择一行要编辑的数据");
        return;
      }
      this.formTitle = '编辑配置';
      this.editForm = Object.assign({}, this.currentRow);
      this.formVisible = true;
    },
    handleDel() {
      if (!this.currentRow) {
        this.$message.error("请先选择要删除的数据");
        return;
      }
      this.$confirm("确认删除该配置项吗?", "提示", { type: "warning" }).then(() => {
        this.listLoading = true;
        removeWorkItemConfig({ id: this.currentRow.Id }).then((res) => {
          this.listLoading = false;
          if (res.success) {
            this.$message.success("删除成功");
            this.handleQuery();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    formSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          let para = Object.assign({}, this.editForm);
          saveWorkItemConfig(para).then((res) => {
            this.formLoading = false;
            let result = res.data || res;
            if (result.success) {
              this.$message.success(result.msg || "提交成功");
              this.formVisible = false;
              this.handleQuery();
            } else {
              this.$message.error(result.msg || "提交失败");
            }
          });
        }
      });
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    console.log("[WorkRecordDebug] WorkItemConfig.mounted", {
      component: "WorkItemConfig",
      routePath: this.$route.path,
      expectedApi: "/api/WorkRecordAdmin/GetConfigs"
    });
  }
};
</script>

<style scoped>
.custom-tbl ::v-deep .has-gutter .el-checkbox {
  display: none;
}

/* 窄屏响应式优化：防止编辑/新增工作记录配置弹窗在窄屏/分栏下太挤 */
@media (max-width: 992px) {
  ::v-deep .el-dialog {
    width: 92% !important;
  }
  ::v-deep .el-dialog .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    margin-bottom: 16px;
  }
  ::v-deep .el-dialog .el-form-item__label {
    width: 100% !important;
    text-align: left !important;
    padding: 0 0 6px !important;
    line-height: 1.35 !important;
    font-weight: 600;
    color: #334155;
  }
  ::v-deep .el-dialog .el-form-item__content {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
</style>
